import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReactSVG } from "react-svg";

import clsx from "clsx";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

import Steps from "../../Steps";
import Button from "../../../../common/Button";
import EndServiceModel from "../../../../common/EndServiceModel";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import QuestionCard from "./question-card";
import CustomInput from "../../../../common/CustomInput";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import NewToolTip from "../../../../common/New-ToolTip";
import {
  setClinicalServiceSteps,
  updateClinicalService,
} from "../../../../../redux/modules/clinical-services/actions";
import {
  allergensAndIrritantsEnum,
  allergensAndIrritantsEffectiveEnum,
  nasalIrrigationsEffectiveEnum,
  nasalIrrigationsEnum,
  nasalIrrigationsLengthEnum,
  nasalIrrigationsSideEffectsEnum,
  nasalOrOralDecongestantsEnum,
  nasalOrOralDecongestantsEffectiveEnum,
  nasalOrOralDecongestantsLengthEnum,
  nasalOrOralDecongestantsProperUseEnum,
  nasalOrOralDecongestantsSideEffectsEnum,
  oralAntihistaminesEnum,
  oralAntihistaminesLengthEnum,
  oralAntihistaminesEffectiveEnum,
  oralAntihistaminesSideEffectsEnum,
  intranasalCorticosteroidsEnum,
  intranasalCorticosteroidsLengthEnum,
  intranasalCorticosteroidsEffectiveEnum,
  intranasalCorticosteroidsProperUseEnum,
  intranasalCorticosteroidsSideEffectsEnum,
  intranasalAntihistaminesAndCorticosteroidsEnum,
  intranasalAntihistaminesAndCorticosteroidsLengthEnum,
  intranasalAntihistaminesAndCorticosteroidsEffectiveEnum,
  intranasalAntihistaminesAndCorticosteroidsProperUseEnum,
  intranasalAntihistaminesAndCorticosteroidsSideEffectsEnum,
  haveYouSeenEmergencyClinicEnum,
  haveYouSeenWalkInClinicEnum,
  haveYouSeenPrimaryPhysicianEnum,
  HistoryCardOptions,
} from "./data";
import SubNavigation from "../../common/sub-navigation";
import { findLastIndex, scrollX } from "../../../../../helpers/functions";
import { getValidStep, updateStepsValidity } from "../../../text/data";
import {
  AlertConfirmationTypes,
  MinorAilmentStep,
} from "../../../../../helpers/constant";

const History = () => {
  const { clinicalServiceObj, clinicalServiceSteps } = useSelector(
    (state) => state.clinicalService
  );
  const dispatch = useDispatch();

  const [continueSelection, setContinueSelection] = useState(false);
  const [showSelectionPopup, setShowSelectionPopup] = useState(false);
  const [cardListToShow, setCardListToShow] = useState(HistoryCardOptions);
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);
  const [clickedEndService, setClickedEndService] = useState(false);
  const [treatmentAnalysis, setTreatmentAnalysis] = useState(false);
  const [showNoHistoryDialog, setShowNoHistoryDialog] = useState(false);
  const [isEditSelection, setIsEditSelection] = useState(false);
  
  const popupVisibilitySet = useRef(false);
  const treatmentAnalysisLoadedFromStorage = useRef(false);
  const previousServiceId = useRef(null);

  useEffect(() => {
    if (clickedEndService) {
      onNext();
      setClickedEndService(false);
    }
  }, [clinicalServiceSteps, clickedEndService]);

  const handleOptionSelection = useCallback((index) => {
    setCardListToShow((prev) => {
      const updated = prev.map((item, i) => 
        i === index ? { ...item, display: !item.display } : item
      );
      if (updated[index].value === "none" && updated[index].display) {
        return updated.map((val) => 
          val.value !== "none" ? { ...val, display: false } : val
        );
      }
      const noneOption = updated.find((val) => val.value === "none");
      if (noneOption) noneOption.display = false;
      return updated;
    });
  }, []);

  // Removed auto-advance when "None" is selected - user should always see Treatment History page
  // useEffect(() => {
  //   if (
  //     cardListToShow
  //       .filter((val) => val.display)
  //       .findIndex((val) => val.value === "none") >= 0
  //   ) {
  //     onNext();
  //   }
  // }, [continueSelection]);

  useEffect(() => {
    const shownCards = cardListToShow.filter((item) => item.display);

    if (
      shownCards.findIndex((val) => val.value === "oralAntihistamines") >= 0
    ) {
      setOralAntihistamines(true);
    }
    if (
      shownCards.findIndex(
        (val) => val.value === "intranasalCorticosteroids"
      ) >= 0
    ) {
      setIntranasalCorticosteroids(true);
    }
    if (
      shownCards.findIndex(
        (val) => val.value === "intranasalAntihistaminesAndCorticosteroids"
      ) >= 0
    ) {
      setIntranasalAntihistaminesAndCorticosteroids(true);
    }
  }, [cardListToShow]);

  const updateStepsVisibility = async (disable = false) => {
    const updatedServiceSteps = updateStepsValidity(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      disable
    );
    await dispatch(setClinicalServiceSteps(updatedServiceSteps));
  };

  const showSelectionContent = () => {
    return (
      <>
        <div className="mb-4">
          <span className="text-md-sm">
            Have you taken any medications in the past for{" "}
            <strong>Seasonal Allergies?</strong> Select which apply
          </span>
        </div>
        {cardListToShow
          .filter((history) => history.value !== "allergensAndIrritants")
          .map((history) => (
            <Button
              key={history.value}
              type="primary-outline"
              text={history.lable}
              className={`w-full mb-2 ${history.display ? "selected" : ""}`}
              onClick={() => {
                handleOptionSelection(cardListToShow.findIndex((card) => card.value === history.value));
              }}
            />
          ))}
        <div className="mt-4">
          <Button
            type="primary"
            text="Continue"
            className="w-full mb-6"
            disabled={!cardListToShow.filter((val) => val.display)?.length > 0}
            onClick={handleContinueSelection}
          />
        </div>
      </>
    );
  };

  // Conditional content - Start
  const getCard = (value) => {
    switch (value) {
      case "allergensAndIrritants":
        return allergensAndIrritantsEnum;
      case "nasalIrrigations":
        return nasalIrrigationsEnum;
      case "nasalOrOralDecongestants":
        return nasalOrOralDecongestantsEnum;
      case "oralAntihistamines":
        return oralAntihistaminesEnum;
      case "intranasalCorticosteroids":
        return intranasalCorticosteroidsEnum;
      case "intranasalAntihistaminesAndCorticosteroids":
        return intranasalAntihistaminesAndCorticosteroidsEnum;
      default:
        return null;
    }
  };

  const getCardValue = (value) => {
    switch (value) {
      case "allergensAndIrritants":
        return allergensAndIrritants;
      case "nasalIrrigations":
        return nasalIrrigations;
      case "nasalOrOralDecongestants":
        return nasalOrOralDecongestants;
      case "oralAntihistamines":
        return oralAntihistaminesConfirmation;
      case "intranasalCorticosteroids":
        return intranasalCorticosteroidsConfirmation;
      case "intranasalAntihistaminesAndCorticosteroids":
        return intranasalAntihistaminesAndCorticosteroidsConfirmation;
    }
  };

  const handleTreatmentAnalysis = () => {
    if (getMedicalAlertToShow()) {
      setShowMedicalHistoryAlert(true);
    } else {
      setShowNoHistoryDialog(true);
    }
  };

  const getCardComponent = (cardValue, value) => {
    switch (cardValue) {
      case "allergensAndIrritants":
        return customAllergensAndIrritantsComponent(value);
      case "nasalIrrigations":
        return customNasalIrrigationComponent(value);
      case "nasalOrOralDecongestants":
        return customNasalOrOralDecongestantsComponent(value);
      case "oralAntihistamines":
        return customOralAntihistaminesComponent(value);
      case "intranasalCorticosteroids":
        return customIntranasalCorticosteroidsComponent(value);
      case "intranasalAntihistaminesAndCorticosteroids":
        return customIntranasalAntihistaminesAndCorticosteroidsComponent(value);
    }
  };

  const getCardComponentOptionClick = (cardValue, value) => {
    switch (cardValue) {
      case "allergensAndIrritants":
        scrollX("treatmentHistory");
        setAllergensAndIrritants(value);
        // Clear effectiveness and comments if "No" is selected
        if (value === "no") {
          setAllergensAndIrritantsEffective(null);
          setAllergensAndIrritantsComments("");
        }
        return;
      case "nasalIrrigations":
        return nasalIrrigationsMultiSelect(value);
      case "nasalOrOralDecongestants":
        scrollX("treatmentHistory");
        return nasalOrOralMultiSelect(value);
      case "oralAntihistamines":
        scrollX("treatmentHistory");
        return setOralAntihistaminesConfirmation(value);
      case "intranasalCorticosteroids":
        scrollX("treatmentHistory");
        return setIntranasalCorticosteroidsConfirmation(value);
      case "intranasalAntihistaminesAndCorticosteroids":
        scrollX("treatmentHistory");
        return setIntranasalAntihistaminesAndCorticosteroidsConfirmation(value);
    }
  };

  const { serviceId } = useParams();
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const getSelectionCompletedKey = () => 
    `history_selection_completed_${serviceId}_${currentStep}_${currentSubStep}`;
  
  const hasCompletedSelection = () => 
    sessionStorage.getItem(getSelectionCompletedKey()) === 'true';
  
  const markSelectionCompleted = () => 
    sessionStorage.setItem(getSelectionCompletedKey(), 'true');

  const getTreatmentAnalysisKey = () => 
    `history_treatment_analysis_${serviceId}_${currentStep}_${currentSubStep}`;
  
  const hasCompletedTreatmentAnalysis = () => 
    sessionStorage.getItem(getTreatmentAnalysisKey()) === 'true';
  
  const markTreatmentAnalysisCompleted = () => 
    sessionStorage.setItem(getTreatmentAnalysisKey(), 'true');

  const ALLERGEN_CARD = {
    lable: "Allergen/Irritant Avoidance",
    value: "allergensAndIrritants",
    display: true,
    cardIndex: 1,
    isMulti: false,
  };

  const handleContinueSelection = useCallback(() => {
    setShowSelectionPopup(false);
    setIsEditSelection(false);
    markSelectionCompleted();
    scrollX("treatmentHistory");
    
    const selectedCardValues = cardListToShow
      .filter((card) => card.display && card.value !== "none")
      .map((card) => card.value);
    
    const updatedCardList = cardListToShow
      .map((card) => ({
        ...card,
        display: card.value === "allergensAndIrritants" 
          ? true 
          : card.value === "none" 
          ? false 
          : selectedCardValues.includes(card.value)
      }))
      .sort((a, b) => (a.cardIndex || 999) - (b.cardIndex || 999));
    
    if (!updatedCardList.some((card) => card.value === "allergensAndIrritants")) {
      updatedCardList.unshift(ALLERGEN_CARD);
    }
    
    setCardListToShow(updatedCardList);
    
    const selectedCards = updatedCardList.filter(
      (card) => card.display && card.value !== "allergensAndIrritants" && card.value !== "none"
    );
    
    const treatment = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment || {};
    const updatedTreatment = initializeTreatmentForSelectedCards(selectedCards, treatment);
    
    dispatch(updateClinicalService(serviceId, {
      treatment: updatedTreatment,
      currentStep,
      currentSubStep,
      showReferral: showRef,
      serviceSteps: clinicalServiceSteps,
    }));
    
    resetCardsForUnselected(updatedCardList, {
      nasalIrrigations: resetNasalIrrigations,
      nasalOrOralDecongestants: resetNasalOrOralDecongestants,
      oralAntihistamines: resetOralAntihistamines,
      intranasalCorticosteroids: resetIntranasalCorticosteroids,
      intranasalAntihistaminesAndCorticosteroids: resetIntranasalAntihistaminesAndCorticosteroids,
    });
    
    setTimeout(() => {
      document.querySelector('[data-card-value="allergensAndIrritants"]')?.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest', 
        inline: 'start' 
      }) || scrollX("treatmentHistory", 0);
    }, 100);
    
    setContinueSelection(true);
  }, [cardListToShow, clinicalServiceObj, serviceId, currentStep, currentSubStep, showRef, clinicalServiceSteps, dispatch]);

  const getCardDisplayState = (treatment) => {
    if (!treatment) return {};
    return {
      nasalIrrigations: Array.isArray(treatment.nasalIrrigations) && treatment.nasalIrrigations.length > 0,
      nasalOrOralDecongestants: Array.isArray(treatment.nasalOrOralDecongestants) && treatment.nasalOrOralDecongestants.length > 0,
      oralAntihistamines: treatment.oralAntihistamines === true,
      intranasalCorticosteroids: treatment.intranasalCorticosteroids === true,
      intranasalAntihistaminesAndCorticosteroids: treatment.intranasalAntihistaminesAndCorticosteroids === true,
    };
  };

  const initializeTreatmentForSelectedCards = (selectedCards, treatment = {}) => {
    const updated = { ...treatment, allergensAndIrritants: treatment.allergensAndIrritants ?? null };
    const cardValueMap = {
      nasalIrrigations: () => updated.nasalIrrigations || (updated.nasalIrrigations = []),
      nasalOrOralDecongestants: () => updated.nasalOrOralDecongestants || (updated.nasalOrOralDecongestants = []),
      oralAntihistamines: () => updated.oralAntihistamines ?? (updated.oralAntihistamines = null),
      intranasalCorticosteroids: () => updated.intranasalCorticosteroids ?? (updated.intranasalCorticosteroids = null),
      intranasalAntihistaminesAndCorticosteroids: () => updated.intranasalAntihistaminesAndCorticosteroids ?? (updated.intranasalAntihistaminesAndCorticosteroids = null),
    };
    selectedCards.forEach((card) => cardValueMap[card.value]?.());
    return updated;
  };

  const resetCardsForUnselected = (cardList, resetFunctions) => {
    const resetMap = {
      nasalIrrigations: resetFunctions.nasalIrrigations,
      nasalOrOralDecongestants: resetFunctions.nasalOrOralDecongestants,
      oralAntihistamines: resetFunctions.oralAntihistamines,
      intranasalCorticosteroids: resetFunctions.intranasalCorticosteroids,
      intranasalAntihistaminesAndCorticosteroids: resetFunctions.intranasalAntihistaminesAndCorticosteroids,
    };
    Object.entries(resetMap).forEach(([value, resetFn]) => {
      if (!cardList.find((card) => card.value === value)?.display && resetFn) {
        resetFn();
      }
    });
  };

  const [subStepComplete, setSubStepComplete] = useState(false);
  const [showMedicalHistoryAlert, setShowMedicalHistoryAlert] = useState(false);
  const [showTreatmentHistoryAlert, setShowTreatmentHistoryAlert] =
    useState(false);
  const [visitedPrimaryPhysician, setVisitedPrimaryPhysician] = useState("");
  const [visitedWalkInClinic, setVisitedWalkInClinic] = useState("");
  const [visitedEmergencyClinic, setVisitedEmergencyClinic] = useState("");
  const [alertConfirmation, setAlertConfirmation] = useState(0);
  const [alertExplaination, setAlertExplaination] = useState("");

  //card - Allergens and Irritants
  const [allergensAndIrritants, setAllergensAndIrritants] = useState("");
  const [allergensAndIrritantsEffective, setAllergensAndIrritantsEffective] = useState(null);
  const [allergensAndIrritantsComments, setAllergensAndIrritantsComments] = useState("");

  //card - Nasal Irrigations, Sprays, or Lubricants
  const [nasalIrrigations, setNasalIrrigations] = useState([]);
  const [nasalIrrigationsLength, setNasalIrrigationsLength] = useState("");
  const [nasalIrrigationsEffective, setNasalIrrigationsEffective] =
    useState("");
  const [nasalIrrigationsSideEffects, setNasalIrrigationsSideEffects] =
    useState("");
  const [nasalIrrigationsComments, setNasalIrrigationsComments] = useState("");

  //card - Nasal or Oral Decongestants
  const [nasalOrOralDecongestants, setNasalOrOralDecongestants] = useState([]);
  const [
    nasalOrOralDecongestantsComments,
    setNasalOrOralDecongestantsComments,
  ] = useState("");
  const [nasalOrOralDecongestantsLength, setNasalOrOralDecongestantsLength] =
    useState("");
  const [
    nasalOrOralDecongestantsEffective,
    setNasalOrOralDecongestantsEffective,
  ] = useState("");
  const [
    nasalOrOralDecongestantsSideEffects,
    setNasalOrOralDecongestantsSideEffects,
  ] = useState("");
  const [
    nasalOrOralDecongestantsProperUse,
    setNasalOrOralDecongestantsProperUse,
  ] = useState("");

  //card - Oral Antihistamines
  const [oralAntihistamines, setOralAntihistamines] = useState(false);
  const [oralAntihistaminesComments, setOralAntihistaminesComments] =
    useState("");
  const [oralAntihistaminesConfirmation, setOralAntihistaminesConfirmation] =
    useState("yes");
  const [oralAntihistaminesLength, setOralAntihistaminesLength] = useState("");
  const [oralAntihistaminesEffective, setOralAntihistaminesEffective] =
    useState("");
  const [oralAntihistaminesSideEffects, setOralAntihistaminesSideEffects] =
    useState("");

  //card - Intranasal Corticosteroids
  const [intranasalCorticosteroids, setIntranasalCorticosteroids] =
    useState(false);
  const [
    intranasalCorticosteroidsComments,
    setIntranasalCorticosteroidsComments,
  ] = useState("");
  const [
    intranasalCorticosteroidsConfirmation,
    setIntranasalCorticosteroidsConfirmation,
  ] = useState("yes");
  const [intranasalCorticosteroidsLength, setIntranasalCorticosteroidsLength] =
    useState("");
  const [
    intranasalCorticosteroidsEffective,
    setIntranasalCorticosteroidsEffective,
  ] = useState("");
  const [
    intranasalCorticosteroidsProperUse,
    setIntranasalCorticosteroidsProperUse,
  ] = useState("");
  const [
    intranasalCorticosteroidsSideEffects,
    setIntranasalCorticosteroidsSideEffects,
  ] = useState("");

  //card - Intranasal Antihistamine/Corticosteroid
  const [
    intranasalAntihistaminesAndCorticosteroids,
    setIntranasalAntihistaminesAndCorticosteroids,
  ] = useState(false);
  const [
    intranasalAntihistaminesAndCorticosteroidsComments,
    setIntranasalAntihistaminesAndCorticosteroidsComments,
  ] = useState("");
  const [
    intranasalAntihistaminesAndCorticosteroidsConfirmation,
    setIntranasalAntihistaminesAndCorticosteroidsConfirmation,
  ] = useState("yes");
  const [
    intranasalAntihistaminesAndCorticosteroidsLength,
    setIntranasalAntihistaminesAndCorticosteroidsLength,
  ] = useState("");
  const [
    intranasalAntihistaminesAndCorticosteroidsEffective,
    setIntranasalAntihistaminesAndCorticosteroidsEffective,
  ] = useState("");
  const [
    intranasalAntihistaminesAndCorticosteroidsProperUse,
    setIntranasalAntihistaminesAndCorticosteroidsProperUse,
  ] = useState("");
  const [
    intranasalAntihistaminesAndCorticosteroidsSideEffects,
    setIntranasalAntihistaminesAndCorticosteroidsSideEffects,
  ] = useState("");

  const scrollAhead = (x = null) => {
    scrollX("treatmentHistory", x);
  };

  const resetNasalIrrigations = () => {
    setNasalIrrigations([]);
    setNasalIrrigationsLength("");
    setNasalIrrigationsEffective("");
    setNasalIrrigationsSideEffects("");
    setNasalIrrigationsComments("");
  };

  const resetNasalOrOralDecongestants = () => {
    setNasalOrOralDecongestants([]);
    setNasalOrOralDecongestantsComments("");
    setNasalOrOralDecongestantsLength("");
    setNasalOrOralDecongestantsEffective("");
    setNasalOrOralDecongestantsSideEffects("");
    setNasalOrOralDecongestantsProperUse("");
  };

  const resetOralAntihistamines = () => {
    setOralAntihistamines(false);
    setOralAntihistaminesComments("");
    setOralAntihistaminesConfirmation("");
    setOralAntihistaminesLength("");
    setOralAntihistaminesEffective("");
    setOralAntihistaminesSideEffects("");
  };
  const resetIntranasalCorticosteroids = () => {
    setIntranasalCorticosteroids(false);
    setIntranasalCorticosteroidsConfirmation("");
    setIntranasalCorticosteroidsComments("");
    setIntranasalCorticosteroidsLength("");
    setIntranasalCorticosteroidsEffective("");
    setIntranasalCorticosteroidsProperUse("");
    setIntranasalCorticosteroidsSideEffects("");
  };

  const resetIntranasalAntihistaminesAndCorticosteroids = () => {
    setIntranasalAntihistaminesAndCorticosteroids(false);
    setIntranasalAntihistaminesAndCorticosteroidsConfirmation("");
    setIntranasalAntihistaminesAndCorticosteroidsComments("");
    setIntranasalAntihistaminesAndCorticosteroidsLength("");
    setIntranasalAntihistaminesAndCorticosteroidsEffective("");
    setIntranasalAntihistaminesAndCorticosteroidsProperUse("");
    setIntranasalAntihistaminesAndCorticosteroidsSideEffects("");
  };

  const nasalIrrigationsMultiSelect = (value) => {
    if (value === "none") {
      setNasalIrrigations(["none"]);
    } else {
      setNasalIrrigations((prev) => {
        if (prev.includes(value)) {
          return prev.filter((item) => item !== value);
        } else {
          if (prev.includes("none")) {
            return [value];
          } else {
            return [...prev, value];
          }
        }
      });
    }
  };

  const nasalOrOralMultiSelect = (value) => {
    if (value === "none") {
      setNasalOrOralDecongestants(["none"]);
    } else {
      setNasalOrOralDecongestants((prev) => {
        if (prev.includes(value)) {
          return prev.filter((item) => item !== value);
        } else {
          if (prev.includes("none")) {
            return [value];
          } else {
            return [...prev, value];
          }
        }
      });
    }
  };

  useEffect(() => {
    if (showSelectionPopup || !clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment) {
      return;
    }
    
    const treatment = clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment;
    const hasRealTreatmentData = 
      treatment.allergensAndIrritants !== null ||
      (treatment.nasalIrrigations?.length > 0) ||
      (treatment.nasalOrOralDecongestants?.length > 0) ||
      treatment.oralAntihistamines === true ||
      treatment.intranasalCorticosteroids === true ||
      treatment.intranasalAntihistaminesAndCorticosteroids === true;
    
    if (!hasRealTreatmentData && !continueSelection) {
      return;
    }
    
    if (continueSelection) {
      if (!cardListToShow.find((card) => card.value === "allergensAndIrritants")) {
        setCardListToShow([ALLERGEN_CARD, ...cardListToShow]);
      }
      return;
    }
    
    const displayState = getCardDisplayState(treatment);
    const updatedCardList = cardListToShow.map((card) => {
      if (card.value === "allergensAndIrritants") {
        return { ...card, display: true };
      }
      return { ...card, display: displayState[card.value] || false };
    });
    
    if (!updatedCardList.some((card) => card.value === "allergensAndIrritants")) {
      updatedCardList.unshift(ALLERGEN_CARD);
    }
    
    setCardListToShow(updatedCardList);

    if (treatment.allergensAndIrritants !== null) {
        setAllergensAndIrritants(treatment.allergensAndIrritants);
        setAllergensAndIrritantsEffective(
          treatment.allergensAndIrritantsEffective ?? null
        );
        setAllergensAndIrritantsComments(
          treatment.allergensdAndIrritantsComments || treatment.allergensAndIrritantsComments || ""
        );
        setNasalIrrigations(treatment.nasalIrrigations);
        setNasalIrrigationsLength(treatment.nasalIrrigationsLength);
        setNasalIrrigationsEffective(treatment.nasalIrrigationsEffective);
        setNasalIrrigationsSideEffects(treatment.nasalIrrigationsSideEffects);
        setNasalIrrigationsComments(treatment.nasalIrrigationsComments);
        setNasalOrOralDecongestants(treatment.nasalOrOralDecongestants);
        setNasalOrOralDecongestantsComments(
          treatment.nasalOrOralDecongestantsComments
        );
        setNasalOrOralDecongestantsLength(
          treatment.nasalOrOralDecongestantsLength
        );
        setNasalOrOralDecongestantsEffective(
          treatment.nasalOrOralDecongestantsEffective
        );
        setNasalOrOralDecongestantsSideEffects(
          treatment.nasalOrOralDecongestantsSideEffects
        );
        setNasalOrOralDecongestantsProperUse(
          treatment.nasalOrOralDecongestantsProperUse
        );
        setOralAntihistamines(treatment.oralAntihistamines);
        setOralAntihistaminesComments(treatment.oralAntihistaminesComments);
        setOralAntihistaminesConfirmation(
          treatment.oralAntihistaminesConfirmation
        );
        setOralAntihistaminesLength(treatment.oralAntihistaminesLength);
        setOralAntihistaminesEffective(treatment.oralAntihistaminesEffective);
        setOralAntihistaminesSideEffects(
          treatment.oralAntihistaminesSideEffects
        );
        setIntranasalCorticosteroids(treatment.intranasalCorticosteroids);
        setIntranasalCorticosteroidsComments(
          treatment.intranasalCorticosteroidsComments
        );
        setIntranasalCorticosteroidsConfirmation(
          treatment.intranasalCorticosteroidsConfirmation
        );
        setIntranasalCorticosteroidsLength(
          treatment.intranasalCorticosteroidsLength
        );
        setIntranasalCorticosteroidsEffective(
          treatment.intranasalCorticosteroidsEffective
        );
        setIntranasalCorticosteroidsProperUse(
          treatment.intranasalCorticosteroidsProperUse
        );
        setIntranasalCorticosteroidsSideEffects(
          treatment.intranasalCorticosteroidsSideEffects
        );
        setIntranasalAntihistaminesAndCorticosteroids(
          treatment.intranasalAntihistaminesAndCorticosteroids
        );
        setIntranasalAntihistaminesAndCorticosteroidsComments(
          treatment.intranasalAntihistaminesAndCorticosteroidsComments
        );
        setIntranasalAntihistaminesAndCorticosteroidsConfirmation(
          treatment.intranasalAntihistaminesAndCorticosteroidsConfirmation
        );
        setIntranasalAntihistaminesAndCorticosteroidsLength(
          treatment.intranasalAntihistaminesAndCorticosteroidsLength
        );
        setIntranasalAntihistaminesAndCorticosteroidsEffective(
          treatment.intranasalAntihistaminesAndCorticosteroidsEffective
        );
        setIntranasalAntihistaminesAndCorticosteroidsProperUse(
          treatment.intranasalAntihistaminesAndCorticosteroidsProperUse
        );
        setIntranasalAntihistaminesAndCorticosteroidsSideEffects(
          treatment.intranasalAntihistaminesAndCorticosteroidsSideEffects
        );
        setVisitedPrimaryPhysician(treatment.visitedPrimaryPhysician);
        setVisitedWalkInClinic(treatment.visitedWalkInClinic);
        setVisitedEmergencyClinic(treatment.visitedEmergencyClinic);
        scrollAhead(900);
      }
  }, [clinicalServiceObj.initialAssessment.initialAssessmentForm, showSelectionPopup, continueSelection]);

  useEffect(() => {
    if (!serviceId || !currentStep || !currentSubStep) return;

    if (previousServiceId.current !== null && previousServiceId.current !== serviceId) {
      const oldId = previousServiceId.current;
      sessionStorage.removeItem(`history_selection_completed_${oldId}_${currentStep}_${currentSubStep}`);
      sessionStorage.removeItem(`history_treatment_analysis_${oldId}_${currentStep}_${currentSubStep}`);
      popupVisibilitySet.current = false;
      treatmentAnalysisLoadedFromStorage.current = false;
    }
    previousServiceId.current = serviceId;

    const popupKey = `${serviceId}_${currentStep}_${currentSubStep}`;
    if (popupVisibilitySet.current === popupKey) return;
    popupVisibilitySet.current = popupKey;

    const treatment = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
    const hasTreatmentData = treatment && (
      treatment.allergensAndIrritants !== null ||
      treatment.nasalIrrigations?.length > 0 ||
      treatment.nasalOrOralDecongestants?.length > 0 ||
      treatment.oralAntihistamines !== null ||
      treatment.intranasalCorticosteroids !== null ||
      treatment.intranasalAntihistaminesAndCorticosteroids !== null
    );
    const isRollingBack = hasCompletedSelection() && hasTreatmentData;

    if (isRollingBack) {
      setShowSelectionPopup(false);
      setContinueSelection(true);
      const analysisCompleted = hasCompletedTreatmentAnalysis();
      setTreatmentAnalysis(analysisCompleted);
      treatmentAnalysisLoadedFromStorage.current = analysisCompleted;
    } else {
      sessionStorage.removeItem(getSelectionCompletedKey());
      sessionStorage.removeItem(getTreatmentAnalysisKey());
      treatmentAnalysisLoadedFromStorage.current = false;
      setShowSelectionPopup(true);
      setContinueSelection(false);
      setTreatmentAnalysis(false);
    }
  }, [serviceId, currentStep, currentSubStep]);

  useEffect(() => {
    if (showSelectionPopup && !continueSelection) {
      const treatment = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
      const hasTreatmentData = treatment && (
        treatment.allergensAndIrritants !== null ||
        treatment.nasalIrrigations?.length > 0 ||
        treatment.nasalOrOralDecongestants?.length > 0 ||
        treatment.oralAntihistamines === true ||
        treatment.intranasalCorticosteroids === true ||
        treatment.intranasalAntihistaminesAndCorticosteroids === true
      );
      
      if (!hasTreatmentData) {
        setCardListToShow(HistoryCardOptions.map((card) => ({ ...card, display: false })));
      }
    }
  }, [showSelectionPopup, continueSelection]);

  // Auto-scroll to allergen card when it first appears and is not filled
  useEffect(() => {
    if (!showSelectionPopup && continueSelection) {
      const allergenCard = cardListToShow.find(
        (card) => card.value === "allergensAndIrritants" && card.display
      );
      if (allergenCard && (allergensAndIrritants === "" || allergensAndIrritants === null)) {
        // Scroll to allergen card after a short delay to ensure it's rendered
        setTimeout(() => {
          const allergenCardElement = document.querySelector('[data-card-value="allergensAndIrritants"]');
          if (allergenCardElement) {
            allergenCardElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          } else {
            // Fallback: scroll to the beginning of treatmentHistory container
            scrollX("treatmentHistory", 0);
          }
        }, 200);
      }
    }
  }, [continueSelection, showSelectionPopup, cardListToShow, allergensAndIrritants]);

  const customAllergensAndIrritantsComponent = (input) => {
    // Show second question and comments only if "Yes" is selected
    if (allergensAndIrritants !== "yes") {
      return null;
    }

    return (
      <div className="flex flex-col gap-4 mt-4">
        <div className="flex flex-col gap-4">
          <p className="text-lg text-gray-800">
            <span className="font-semibold">
              {allergensAndIrritantsEffectiveEnum.question}
            </span>
          </p>
          <div className="flex flex-col gap-2">
            {allergensAndIrritantsEffectiveEnum.options.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  setAllergensAndIrritantsEffective(option.value);
                  scrollX("treatmentHistory");
                }}
                className={clsx(
                  `text-body-md p-3 rounded-[4px] border-[1px]
                  text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                  allergensAndIrritantsEffective === option.value &&
                    "bg-gray-20 border-gray-600",
                  allergensAndIrritantsEffective !== option.value &&
                    "bg-white border-gray-100"
                )}
              >
                <p className="text-body-md flex justify-start items-start">
                  {option.header}
                </p>
              </button>
            ))}
          </div>
        </div>
        <CustomInput
          name={input?.name || "allergensdAndIrritantsComments"}
          className="col-span-12 mt-4"
          label={input?.label || ""}
          placeholder={input?.placeholder || "Comments (Optional)"}
          type={input?.type || "textarea"}
          value={allergensAndIrritantsComments}
          onChange={(e) => setAllergensAndIrritantsComments(e.target.value)}
        />
      </div>
    );
  };

  const customNasalIrrigationComponent = (input) => {
    return (
      <div className="flex flex-col gap-4">
        {nasalIrrigations?.length > 0 &&
          !nasalIrrigations?.includes("none") && (
            <div className="flex flex-col gap-4">
              {
                <>
                  <div className="flex flex-col gap-4" id="nasalIrrigationsLength">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalIrrigationsLengthEnum.question}
                      </span>
                      <br />
                      {nasalIrrigationsLengthEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalIrrigationsLengthEnum.options.map((option) => {
                        return (
                          <>
                            <button
                              onClick={() => {
                                setNasalIrrigationsLength(option.value);
                                setTimeout(() => {
                                  const el = document.getElementById('nasalIrrigationsEffective');
                                  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }, 100);
                              }}
                              className={clsx(
                                `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                nasalIrrigationsLength === option.value &&
                                  "bg-gray-20 border-gray-600",
                                nasalIrrigationsLength !== option.value &&
                                  "bg-white border-gray-100"
                              )}
                            >
                              <p className="text-body-md flex justify-start items-start">
                                {option.header}
                              </p>
                              <p className="text-gray-600 text-body-md flex justify-start items-start">
                                {option.subHeader}
                              </p>
                            </button>
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex flex-col gap-4" id="nasalIrrigationsEffective">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalIrrigationsEffectiveEnum.question}
                      </span>
                      <br />
                      {nasalIrrigationsEffectiveEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalIrrigationsEffectiveEnum.options.map((option) => {
                        return (
                          <>
                            <button
                              onClick={() =>
                                setNasalIrrigationsEffective(option.value)
                              }
                              className={clsx(
                                `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                nasalIrrigationsEffective === option.value &&
                                  "bg-gray-20 border-gray-600",
                                nasalIrrigationsEffective !== option.value &&
                                  "bg-white border-gray-100"
                              )}
                            >
                              <p className="text-body-md flex justify-start items-start">
                                {option.header}
                              </p>
                              <p className="text-gray-600 text-body-md flex justify-start items-start">
                                {option.subHeader}
                              </p>
                            </button>
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex flex-col gap-4" id="nasalIrrigationsSideEffects">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalIrrigationsSideEffectsEnum.question}
                      </span>
                      <br />
                      {nasalIrrigationsSideEffectsEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalIrrigationsSideEffectsEnum.options.map((option) => {
                        return (
                          <>
                            <button
                              onClick={() =>
                                setNasalIrrigationsSideEffects(option.value)
                              }
                              className={clsx(
                                `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                nasalIrrigationsSideEffects === option.value &&
                                  "bg-gray-20 border-gray-600",
                                nasalIrrigationsSideEffects !== option.value &&
                                  "bg-white border-gray-100"
                              )}
                            >
                              <p className="text-body-md flex justify-start items-start">
                                {option.header}
                              </p>
                              <p className="text-gray-600 text-body-md flex justify-start items-start">
                                {option.subHeader}
                              </p>
                            </button>
                          </>
                        );
                      })}
                    </div>
                  </div>
                </>
              }
            </div>
          )}
        <CustomInput
          name={input.name}
          className="col-span-12 mt-9"
          label={input.label}
          placeholder={input.placeholder}
          type={input.type}
          value={nasalIrrigationsComments}
          onChange={(e) => setNasalIrrigationsComments(e.target.value)}
        />
      </div>
    );
  };

  const customNasalOrOralDecongestantsComponent = (input) => {
    return (
      <div className="flex flex-col gap-4">
        {nasalOrOralDecongestants?.length > 0 &&
          !nasalOrOralDecongestants?.includes("none") && (
            <div className="flex flex-col gap-4">
              {
                <>
                  <div className="flex flex-col gap-4" id="nasalOrOralDecongestantsLength">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalOrOralDecongestantsLengthEnum.question}
                      </span>
                      <br />
                      {nasalOrOralDecongestantsLengthEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalOrOralDecongestantsLengthEnum.options.map(
                        (option) => {
                          return (
                            <>
                              <button
                                onClick={() => {
                                  setNasalOrOralDecongestantsLength(option.value);
                                  setTimeout(() => {
                                    const el = document.getElementById('nasalOrOralDecongestantsEffective');
                                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                  }, 100);
                                }}
                                className={clsx(
                                  `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                  nasalOrOralDecongestantsLength ===
                                    option.value &&
                                    "bg-gray-20 border-gray-600",
                                  nasalOrOralDecongestantsLength !==
                                    option.value && "bg-white border-gray-100"
                                )}
                              >
                                <p className="text-body-md flex justify-start items-start">
                                  {option.header}
                                </p>
                                <p className="text-gray-600 text-body-md flex justify-start items-start">
                                  {option.subHeader}
                                </p>
                              </button>
                            </>
                          );
                        }
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-4" id="nasalOrOralDecongestantsEffective">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalOrOralDecongestantsEffectiveEnum.question}
                      </span>
                      <br />
                      {nasalOrOralDecongestantsEffectiveEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalOrOralDecongestantsEffectiveEnum.options.map(
                        (option) => {
                          return (
                            <>
                              <button
                                onClick={() =>
                                  setNasalOrOralDecongestantsEffective(
                                    option.value
                                  )
                                }
                                className={clsx(
                                  `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                  nasalOrOralDecongestantsEffective ===
                                    option.value &&
                                    "bg-gray-20 border-gray-600",
                                  nasalOrOralDecongestantsEffective !==
                                    option.value && "bg-white border-gray-100"
                                )}
                              >
                                <p className="text-body-md flex justify-start items-start">
                                  {option.header}
                                </p>
                                <p className="text-gray-600 text-body-md flex justify-start items-start">
                                  {option.subHeader}
                                </p>
                              </button>
                            </>
                          );
                        }
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-4" id="nasalOrOralDecongestantsProperUse">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalOrOralDecongestantsProperUseEnum.question}
                      </span>
                      <br />
                      {nasalOrOralDecongestantsProperUseEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalOrOralDecongestantsProperUseEnum.options.map(
                        (option) => {
                          return (
                            <>
                              <button
                                onClick={() =>
                                  setNasalOrOralDecongestantsProperUse(
                                    option.value
                                  )
                                }
                                className={clsx(
                                  `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                  nasalOrOralDecongestantsProperUse ===
                                    option.value &&
                                    "bg-gray-20 border-gray-600",
                                  nasalOrOralDecongestantsProperUse !==
                                    option.value && "bg-white border-gray-100"
                                )}
                              >
                                <p className="text-body-md flex justify-start items-start">
                                  {option.header}
                                </p>
                                <p className="text-gray-600 text-body-md flex justify-start items-start">
                                  {option.subHeader}
                                </p>
                              </button>
                            </>
                          );
                        }
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-4" id="nasalOrOralDecongestantsSideEffects">
                    <p className="text-lg text-gray-800">
                      <span className="font-semibold">
                        {nasalOrOralDecongestantsSideEffectsEnum.question}
                      </span>
                      <br />
                      {nasalOrOralDecongestantsSideEffectsEnum.subquestion}
                    </p>
                    <div className="flex flex-col gap-2">
                      {nasalOrOralDecongestantsSideEffectsEnum.options.map(
                        (option) => {
                          return (
                            <>
                              <button
                                onClick={() =>
                                  setNasalOrOralDecongestantsSideEffects(
                                    option.value
                                  )
                                }
                                className={clsx(
                                  `font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                                  nasalOrOralDecongestantsSideEffects ===
                                    option.value &&
                                    "bg-gray-20 border-gray-600",
                                  nasalOrOralDecongestantsSideEffects !==
                                    option.value && "bg-white border-gray-100"
                                )}
                              >
                                <p className="text-body-md flex justify-start items-start">
                                  {option.header}
                                </p>
                                <p className="text-gray-600 text-body-md flex justify-start items-start">
                                  {option.subHeader}
                                </p>
                              </button>
                            </>
                          );
                        }
                      )}
                    </div>
                  </div>
                </>
              }
            </div>
          )}
        <CustomInput
          name={input.name}
          className="col-span-12 mt-9"
          label={input.label}
          placeholder={input.placeholder}
          type={input.type}
          value={nasalOrOralDecongestantsComments}
          onChange={(e) => setNasalOrOralDecongestantsComments(e.target.value)}
        />
      </div>
    );
  };

  const customOralAntihistaminesComponent = (input) => {
    return (
      <div className="flex flex-col gap-4" id="OralAntihistaminesComponent">
        {oralAntihistaminesConfirmation !== "no" &&
          oralAntihistaminesConfirmation !== "notsure" && (
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4" id="oralAntihistaminesLength">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {oralAntihistaminesLengthEnum.question}
                  </span>
                  <br />
                  {oralAntihistaminesLengthEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {oralAntihistaminesLengthEnum.options.map((option) => {
                    return (
                      <button
                        key={option.value}
                        onClick={() => {
                          setOralAntihistaminesLength(option.value);
                          setTimeout(() => {
                            const el = document.getElementById('oralAntihistaminesEffective');
                            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                          }, 100);
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                        text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          oralAntihistaminesLength === option.value &&
                            "bg-gray-20 border-gray-600",
                          oralAntihistaminesLength !== option.value &&
                            "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="oralAntihistaminesEffective">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {oralAntihistaminesEffectiveEnum.question}
                  </span>
                  <br />
                  {oralAntihistaminesEffectiveEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {oralAntihistaminesEffectiveEnum.options.map((option) => {
                    return (
                      <button
                        key={option.value}
                        onClick={() => {
                          setOralAntihistaminesEffective(option.value);
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                        text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          oralAntihistaminesEffective === option.value &&
                            "bg-gray-20 border-gray-600",
                          oralAntihistaminesEffective !== option.value &&
                            "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="oralAntihistaminesSideEffects">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {oralAntihistaminesSideEffectsEnum.question}
                  </span>
                  <br />
                  {oralAntihistaminesSideEffectsEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {oralAntihistaminesSideEffectsEnum.options.map((option) => {
                    return (
                      <button
                        key={option.value}
                        onClick={() => {
                          setOralAntihistaminesSideEffects(option.value);
                          scrollX("treatmentHistory");
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                        text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          oralAntihistaminesSideEffects === option.value &&
                            "bg-gray-20 border-gray-600",
                          oralAntihistaminesSideEffects !== option.value &&
                            "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        {/* If oralAntihistaminesConfirmation is 'no' or 'notsure', scrollX to treatmentHistory */}
        {(oralAntihistaminesConfirmation === "no" || oralAntihistaminesConfirmation === "notsure") && (
          (() => { scrollX("treatmentHistory"); return null; })()
        )}
        <CustomInput
          name={input.name}
          className="col-span-12 mt-9"
          label={input.label}
          placeholder={input.placeholder}
          type={input.type}
          value={oralAntihistaminesComments}
          onChange={(e) => setOralAntihistaminesComments(e.target.value)}
        />
      </div>
    );
  };

  const customIntranasalCorticosteroidsComponent = (input) => {
    return (
      <div
        className="flex flex-col gap-4"
        id="IntranasalCorticosteroidsComponent"
      >
        {intranasalCorticosteroidsConfirmation !== "no" &&
          intranasalCorticosteroidsConfirmation !== "notsure" && (
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4" id="intranasalCorticosteroidsLength">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalCorticosteroidsLengthEnum.question}
                  </span>
                  <br />
                  {intranasalCorticosteroidsLengthEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalCorticosteroidsLengthEnum.options.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => {
                        setIntranasalCorticosteroidsLength(option.value);
                        setTimeout(() => {
                          const el = document.getElementById('intranasalCorticosteroidsEffective');
                          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }, 100);
                      }}
                      className={clsx(
                        `text-body-md p-3 rounded-[4px] border-[1px]
                      text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                        intranasalCorticosteroidsLength === option.value &&
                          "bg-gray-20 border-gray-600",
                        intranasalCorticosteroidsLength !== option.value &&
                          "bg-white border-gray-100"
                      )}
                    >
                      <p className="text-body-md flex justify-start items-start">
                        {option.header}
                      </p>
                      <p className="text-gray-600 text-body-md flex justify-start items-start">
                        {option.subHeader}
                      </p>
                    </button>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalCorticosteroidsEffective">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalCorticosteroidsEffectiveEnum.question}
                  </span>
                  <br />
                  {intranasalCorticosteroidsEffectiveEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalCorticosteroidsEffectiveEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() =>
                          setIntranasalCorticosteroidsEffective(option.value)
                        }
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                      text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalCorticosteroidsEffective === option.value &&
                            "bg-gray-20 border-gray-600",
                          intranasalCorticosteroidsEffective !== option.value &&
                            "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalCorticosteroidsProperUse">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalCorticosteroidsProperUseEnum.question}
                  </span>
                  <br />
                  {intranasalCorticosteroidsProperUseEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalCorticosteroidsProperUseEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() =>
                          setIntranasalCorticosteroidsProperUse(option.value)
                        }
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                      text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalCorticosteroidsProperUse === option.value &&
                            "bg-gray-20 border-gray-600",
                          intranasalCorticosteroidsProperUse !== option.value &&
                            "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalCorticosteroidsSideEffects">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalCorticosteroidsSideEffectsEnum.question}
                  </span>
                  <br />
                  {intranasalCorticosteroidsSideEffectsEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalCorticosteroidsSideEffectsEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setIntranasalCorticosteroidsSideEffects(option.value)
                          scrollX("treatmentHistory");
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalCorticosteroidsSideEffects ===
                            option.value && "bg-gray-20 border-gray-600",
                          intranasalCorticosteroidsSideEffects !==
                            option.value && "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        <CustomInput
          name={input.name}
          className="col-span-12 mt-9"
          label={input.label}
          placeholder={input.placeholder}
          type={input.type}
          value={intranasalCorticosteroidsComments}
          onChange={(e) => setIntranasalCorticosteroidsComments(e.target.value)}
        />
      </div>
    );
  };

  const customIntranasalAntihistaminesAndCorticosteroidsComponent = (input) => {
    return (
      <div
        className="flex flex-col gap-4"
        id="IntranasalAntihistaminesAndCorticosteroidsComponent"
      >
        {intranasalAntihistaminesAndCorticosteroidsConfirmation !== "no" &&
          intranasalAntihistaminesAndCorticosteroidsConfirmation !==
            "notsure" && (
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {
                      intranasalAntihistaminesAndCorticosteroidsLengthEnum.question
                    }
                  </span>
                  <br />
                  {
                    intranasalAntihistaminesAndCorticosteroidsLengthEnum.subquestion
                  }
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalAntihistaminesAndCorticosteroidsLengthEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setIntranasalAntihistaminesAndCorticosteroidsLength(
                            option.value
                          );
                          setTimeout(() => {
                            const el = document.getElementById('intranasalAntihistaminesAndCorticosteroidsEffective');
                            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                          }, 100);
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                      text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalAntihistaminesAndCorticosteroidsLength ===
                            option.value && "bg-gray-20 border-gray-600",
                          intranasalAntihistaminesAndCorticosteroidsLength !==
                            option.value && "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalAntihistaminesAndCorticosteroidsEffective">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalAntihistaminesAndCorticosteroidsEffectiveEnum.question}
                  </span>
                  <br />
                  {intranasalAntihistaminesAndCorticosteroidsEffectiveEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalAntihistaminesAndCorticosteroidsEffectiveEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setIntranasalAntihistaminesAndCorticosteroidsEffective(option.value);
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalAntihistaminesAndCorticosteroidsEffective ===
                            option.value && "bg-gray-20 border-gray-600",
                          intranasalAntihistaminesAndCorticosteroidsEffective !==
                            option.value && "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalAntihistaminesAndCorticosteroidsProperUse">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalAntihistaminesAndCorticosteroidsProperUseEnum.question}
                  </span>
                  <br />
                  {intranasalAntihistaminesAndCorticosteroidsProperUseEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalAntihistaminesAndCorticosteroidsProperUseEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setIntranasalAntihistaminesAndCorticosteroidsProperUse(option.value);
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalAntihistaminesAndCorticosteroidsProperUse ===
                            option.value && "bg-gray-20 border-gray-600",
                          intranasalAntihistaminesAndCorticosteroidsProperUse !==
                            option.value && "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4" id="intranasalAntihistaminesAndCorticosteroidsSideEffects">
                <p className="text-lg text-gray-800">
                  <span className="font-semibold">
                    {intranasalAntihistaminesAndCorticosteroidsSideEffectsEnum.question}
                  </span>
                  <br />
                  {intranasalAntihistaminesAndCorticosteroidsSideEffectsEnum.subquestion}
                </p>
                <div className="flex flex-col gap-2">
                  {intranasalAntihistaminesAndCorticosteroidsSideEffectsEnum.options.map(
                    (option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setIntranasalAntihistaminesAndCorticosteroidsSideEffects(option.value);
                          scrollX("treatmentHistory");
                        }}
                        className={clsx(
                          `text-body-md p-3 rounded-[4px] border-[1px]
                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                          intranasalAntihistaminesAndCorticosteroidsSideEffects ===
                            option.value && "bg-gray-20 border-gray-600",
                          intranasalAntihistaminesAndCorticosteroidsSideEffects !==
                            option.value && "bg-white border-gray-100"
                        )}
                      >
                        <p className="text-body-md flex justify-start items-start">
                          {option.header}
                        </p>
                        <p className="text-gray-600 text-body-md flex justify-start items-start">
                          {option.subHeader}
                        </p>
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        <CustomInput
          name={input.name}
          className="col-span-12 mt-9"
          label={input.label}
          placeholder={input.placeholder}
          type={input.type}
          value={intranasalAntihistaminesAndCorticosteroidsComments}
          onChange={(e) =>
            setIntranasalAntihistaminesAndCorticosteroidsComments(
              e.target.value
            )
          }
        />
      </div>
    );
  };

  const getUnsatisfactoryMediaction = () => {
    const medications = cardListToShow.filter(
      (val) =>
        val.display &&
        ((val.value === "oralAntihistamines" &&
          !oralAntihistaminesEffective &&
          oralAntihistaminesLength === "moreThanTwoWeeks") ||
          (val.value === "intranasalCorticosteroids" &&
            !intranasalCorticosteroidsEffective &&
            intranasalCorticosteroidsLength === "moreThanTwoWeeks" &&
            intranasalCorticosteroidsProperUse) ||
          (val.value === "intranasalAntihistaminesAndCorticosteroids" &&
            !intranasalAntihistaminesAndCorticosteroidsEffective &&
            intranasalAntihistaminesAndCorticosteroidsLength ===
              "moreThanTwoWeeks" &&
            intranasalAntihistaminesAndCorticosteroidsProperUse))
    );
    return medications;
  };

  const renderPopupContent = () => {
    const unsatisfactoryMedications = getUnsatisfactoryMediaction();
    if (showMedicalHistoryAlert) {
      return (
        <div className="flex flex-col gap-4">
          <p className=" text-body-sm">
            Unsatisfactory response with {unsatisfactoryMedications.length}{" "}
            medications even with{" "}
            <strong>proper technique and adherence</strong>:
          </p>
          <p className="text-body-sm">
            {unsatisfactoryMedications.map((val) => (
              <>
                <strong className="text-body-sm">{val.lable}</strong>
                <br />
              </>
            ))}
          </p>
        </div>
      );
    }
    if (showTreatmentHistoryAlert) {
      return (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-[10px] pb-[10px] border-b-[1px] border-gray-20">
            <label
              htmlFor="visitedPrimaryPhysician"
              className="text-gray-600 font-medium text-body-md"
            >
              {haveYouSeenPrimaryPhysicianEnum.question}
            </label>
            <CustomInput
              options={haveYouSeenPrimaryPhysicianEnum.options}
              type="radio"
              name="visitedPrimaryPhysician"
              vertical
              label=""
              className=""
              onChange={(e) => {
                setVisitedPrimaryPhysician(e.target.value);
              }}
              value={visitedPrimaryPhysician}
            />
          </div>
          <div className="flex flex-col gap-[10px] pb-[10px] border-b-[1px] border-gray-20">
            <label
              htmlFor="visitedEmergencyClinic"
              className="text-gray-600 font-medium text-body-md"
            >
              {haveYouSeenEmergencyClinicEnum.question}
            </label>
            <CustomInput
              options={haveYouSeenEmergencyClinicEnum.options}
              type="radio"
              name="visitedEmergencyClinic"
              vertical
              label=""
              className=""
              onChange={(e) => {
                setVisitedEmergencyClinic(e.target.value);
              }}
              value={visitedEmergencyClinic}
            />
          </div>
          <div className="flex flex-col gap-[10px] pb-[10px] border-b-[1px] border-gray-20">
            <label
              htmlFor="visitedWalkInClinic"
              className="text-gray-600 font-medium text-body-md"
            >
              {haveYouSeenWalkInClinicEnum.question}
            </label>
            <CustomInput
              options={haveYouSeenWalkInClinicEnum.options}
              type="radio"
              name="visitedWalkInClinic"
              vertical
              label=""
              className=""
              onChange={(e) => {
                setVisitedWalkInClinic(e.target.value);
              }}
              value={visitedWalkInClinic}
            />
          </div>
        </div>
      );
    }
  };

  const onNext = () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(
        clinicalServiceSteps,
        currentStep,
        currentSubStep,
        1
      );

      const treatment =
        clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment;

      const updatedSteps = {
        treatment: {
          allergensAndIrritants: allergensAndIrritants === "" ? null : allergensAndIrritants,
          allergensAndIrritantsEffective: allergensAndIrritantsEffective === null ? null : !!allergensAndIrritantsEffective,
          // Note: Backend expects "AllergensdAndIrritantsComments" (with typo) to match C# model
          allergensdAndIrritantsComments: allergensAndIrritantsComments,
          nasalIrrigations: nasalIrrigations,
          nasalIrrigationsComments: nasalIrrigationsComments,
          nasalIrrigationsLength:
            nasalIrrigationsLength === "" ? null : nasalIrrigationsLength,
          nasalIrrigationsEffective:
            nasalIrrigationsEffective === ""
              ? null
              : !!nasalIrrigationsEffective,
          nasalIrrigationsSideEffects:
            nasalIrrigationsSideEffects === ""
              ? null
              : !!nasalIrrigationsSideEffects,
          nasalOrOralDecongestants: nasalOrOralDecongestants,
          nasalOrOralDecongestantsComments: nasalOrOralDecongestantsComments,
          nasalOrOralDecongestantsLength:
            nasalOrOralDecongestantsLength === ""
              ? null
              : nasalOrOralDecongestantsLength,
          nasalOrOralDecongestantsEffective:
            nasalOrOralDecongestantsEffective === ""
              ? null
              : !!nasalOrOralDecongestantsEffective,
          nasalOrOralDecongestantsProperUse:
            nasalOrOralDecongestantsProperUse === ""
              ? null
              : !!nasalOrOralDecongestantsProperUse,
          nasalOrOralDecongestantsSideEffects:
            nasalOrOralDecongestantsSideEffects === ""
              ? null
              : !!nasalOrOralDecongestantsSideEffects,
          oralAntihistamines:
            oralAntihistamines === "" ? null : !!oralAntihistamines,
          oralAntihistaminesComments: oralAntihistaminesComments,
          oralAntihistaminesConfirmation:
            oralAntihistaminesConfirmation === ""
              ? null
              : oralAntihistaminesConfirmation,
          oralAntihistaminesLength:
            oralAntihistaminesLength === "" ? null : oralAntihistaminesLength,
          oralAntihistaminesEffective:
            oralAntihistaminesEffective === ""
              ? null
              : !!oralAntihistaminesEffective,
          oralAntihistaminesSideEffects:
            oralAntihistaminesSideEffects === ""
              ? null
              : !!oralAntihistaminesSideEffects,
          intranasalCorticosteroids:
            intranasalCorticosteroids === ""
              ? null
              : !!intranasalCorticosteroids,
          intranasalCorticosteroidsComments: intranasalCorticosteroidsComments,
          intranasalCorticosteroidsConfirmation:
            intranasalCorticosteroidsConfirmation === ""
              ? null
              : intranasalCorticosteroidsConfirmation,
          intranasalCorticosteroidsLength:
            intranasalCorticosteroidsLength === ""
              ? null
              : intranasalCorticosteroidsLength,
          intranasalCorticosteroidsEffective:
            intranasalCorticosteroidsEffective === ""
              ? null
              : !!intranasalCorticosteroidsEffective,
          intranasalCorticosteroidsProperUse:
            intranasalCorticosteroidsProperUse === ""
              ? null
              : !!intranasalCorticosteroidsProperUse,
          intranasalCorticosteroidsSideEffects:
            intranasalCorticosteroidsSideEffects === ""
              ? null
              : !!intranasalCorticosteroidsSideEffects,
          intranasalAntihistaminesAndCorticosteroids:
            intranasalAntihistaminesAndCorticosteroids === ""
              ? null
              : !!intranasalAntihistaminesAndCorticosteroids,
          intranasalAntihistaminesAndCorticosteroidsComments:
            intranasalAntihistaminesAndCorticosteroidsComments,
          intranasalAntihistaminesAndCorticosteroidsConfirmation:
            intranasalAntihistaminesAndCorticosteroidsConfirmation === ""
              ? null
              : intranasalAntihistaminesAndCorticosteroidsConfirmation,
          intranasalAntihistaminesAndCorticosteroidsLength:
            intranasalAntihistaminesAndCorticosteroidsLength === ""
              ? null
              : intranasalAntihistaminesAndCorticosteroidsLength,
          intranasalAntihistaminesAndCorticosteroidsEffective:
            intranasalAntihistaminesAndCorticosteroidsEffective === ""
              ? null
              : !!intranasalAntihistaminesAndCorticosteroidsEffective,
          intranasalAntihistaminesAndCorticosteroidsProperUse:
            intranasalAntihistaminesAndCorticosteroidsProperUse === ""
              ? null
              : !!intranasalAntihistaminesAndCorticosteroidsProperUse,
          intranasalAntihistaminesAndCorticosteroidsSideEffects:
            intranasalAntihistaminesAndCorticosteroidsSideEffects === ""
              ? null
              : !!intranasalAntihistaminesAndCorticosteroidsSideEffects,
          visitedEmergencyClinic:
            visitedEmergencyClinic === "" ? null : visitedEmergencyClinic,
          visitedPrimaryPhysician:
            visitedPrimaryPhysician === "" ? null : visitedPrimaryPhysician,
          visitedWalkInClinic:
            visitedWalkInClinic === "" ? null : visitedWalkInClinic,
          pharmacologicalHistoryConfirmationType: alertConfirmation,
          pharmacologicalHistoryExplaination: alertExplaination,
        },
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        showReferral: showRef,
        serviceSteps: clinicalServiceSteps,
      };
      dispatch(updateClinicalService(serviceId, updatedSteps));
    }
  };

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep };
    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  const getAnyMissingInput = () => {
    const allergenCard = cardListToShow.find(
      (val) => val.value === "allergensAndIrritants"
    );
    
    // Validate allergen card: must be filled, and if "Yes" is selected, effectiveness must also be answered
    const allergensAndIrritantsValidation =
      allergenCard?.display &&
      ((allergensAndIrritants === "" || allergensAndIrritants === null) ||
        (allergensAndIrritants === "yes" &&
          (allergensAndIrritantsEffective === null ||
            allergensAndIrritantsEffective === undefined)));

    let nasalIrrigationValidation =
      cardListToShow.find((val) => val.value === "nasalIrrigations")?.display &&
      (nasalIrrigations.length === 0 ||
        (!nasalIrrigations.includes("none") &&
          (nasalIrrigationsLength === "" ||
            nasalIrrigationsLength === null ||
            nasalIrrigationsEffective === "" ||
            nasalIrrigationsEffective === null ||
            nasalIrrigationsSideEffects === "" ||
            nasalIrrigationsSideEffects === null)));

    let nasalOrOralDecongestantValidation =
      cardListToShow.find((val) => val.value === "nasalOrOralDecongestants")
        ?.display &&
      (nasalOrOralDecongestants.length === 0 ||
        (!nasalOrOralDecongestants.includes("none") &&
          (nasalOrOralDecongestantsLength === "" ||
            nasalOrOralDecongestantsLength === null ||
            nasalOrOralDecongestantsEffective === "" ||
            nasalOrOralDecongestantsEffective === null ||
            nasalOrOralDecongestantsProperUse === "" ||
            nasalOrOralDecongestantsProperUse === null ||
            nasalOrOralDecongestantsSideEffects === "" ||
            nasalOrOralDecongestantsSideEffects === null)));

    let oralAntihistaminesValidation =
      cardListToShow.find((val) => val.value === "oralAntihistamines")
        ?.display &&
      (
        oralAntihistaminesConfirmation === "" || // Check if the first question is answered
        oralAntihistaminesConfirmation === null ||
        (
          oralAntihistaminesConfirmation === "yes" && // If 'yes', then check sub-questions
          (oralAntihistaminesLength === "" ||
            oralAntihistaminesLength === null ||
            oralAntihistaminesEffective === "" ||
            oralAntihistaminesEffective === null ||
            oralAntihistaminesSideEffects === "" ||
            oralAntihistaminesSideEffects === null)
        )
        // If 'no' or 'notsure', no further validation needed
      );

    let intranasalCorticosteroidValidation =
      cardListToShow.find((val) => val.value === "intranasalCorticosteroids")
        ?.display &&
      (
        intranasalCorticosteroidsConfirmation === "" ||
        intranasalCorticosteroidsConfirmation === null ||
        (
          intranasalCorticosteroidsConfirmation === "yes" &&
          (intranasalCorticosteroidsLength === "" ||
            intranasalCorticosteroidsLength === null ||
            intranasalCorticosteroidsEffective === "" ||
            intranasalCorticosteroidsEffective === null ||
            intranasalCorticosteroidsProperUse === "" ||
            intranasalCorticosteroidsProperUse === null ||
            intranasalCorticosteroidsSideEffects === "" ||
            intranasalCorticosteroidsSideEffects === null)
        )
        // If 'no' or 'notsure', no further validation needed
      );

    let intranasalAntihistaminesAndCorticosteroidValidation =
      cardListToShow.find(
        (val) => val.value === "intranasalAntihistaminesAndCorticosteroids"
      )?.display &&
      (
        intranasalAntihistaminesAndCorticosteroidsConfirmation === "" ||
        intranasalAntihistaminesAndCorticosteroidsConfirmation === null ||
        (
          intranasalAntihistaminesAndCorticosteroidsConfirmation === "yes" &&
          (intranasalAntihistaminesAndCorticosteroidsLength === "" ||
            intranasalAntihistaminesAndCorticosteroidsLength === null ||
            intranasalAntihistaminesAndCorticosteroidsEffective === "" ||
            intranasalAntihistaminesAndCorticosteroidsEffective === null ||
            intranasalAntihistaminesAndCorticosteroidsProperUse === "" ||
            intranasalAntihistaminesAndCorticosteroidsProperUse === null ||
            intranasalAntihistaminesAndCorticosteroidsSideEffects === "" ||
            intranasalAntihistaminesAndCorticosteroidsSideEffects === null)
        )
        // If 'no' or 'notsure', no further validation needed
      );

    if (
      allergensAndIrritantsValidation ||
      nasalIrrigationValidation ||
      nasalOrOralDecongestantValidation ||
      oralAntihistaminesValidation ||
      intranasalCorticosteroidValidation ||
      intranasalAntihistaminesAndCorticosteroidValidation
    )
      return true;
    else return false;
  };

  const getMedicalAlertToShow = () => {
    const displayedCard = cardListToShow.filter((val) => val.display);

    const alertContainingCard = displayedCard.filter(
      (val) =>
        val.value === "oralAntihistamines" ||
        val.value === "intranasalCorticosteroids" ||
        val.value === "intranasalAntihistaminesAndCorticosteroids"
    );
    if (alertContainingCard.length < 2) return false;

    const oral = displayedCard.find(
      (val) => val.value === "oralAntihistamines"
    );
    const intranasal = displayedCard.find(
      (val) => val.value === "intranasalCorticosteroids"
    );
    const intranasalAntihistamines = displayedCard.find(
      (val) => val.value === "intranasalAntihistaminesAndCorticosteroids"
    );

    let oralResult = false;
    let intranasalResult = false;
    let intranasalAntihistaminesResult = false;

    if (oral) {
      oralResult =
        oralAntihistaminesConfirmation === "yes" &&
        !oralAntihistaminesEffective &&
        oralAntihistaminesLength === "moreThanTwoWeeks";
    }

    if (intranasal) {
      intranasalResult =
        intranasalCorticosteroidsConfirmation === "yes" &&
        intranasalCorticosteroidsLength === "moreThanTwoWeeks" &&
        !intranasalCorticosteroidsEffective &&
        intranasalCorticosteroidsProperUse;
    }

    if (intranasalAntihistamines) {
      intranasalAntihistaminesResult =
        intranasalAntihistaminesAndCorticosteroidsConfirmation === "yes" &&
        intranasalAntihistaminesAndCorticosteroidsLength ===
          "moreThanTwoWeeks" &&
        !intranasalAntihistaminesAndCorticosteroidsEffective &&
        intranasalAntihistaminesAndCorticosteroidsProperUse;
    }

    let validationCount = 0;

    if (oral && oralResult) validationCount += 1;
    if (intranasal && intranasalResult) validationCount += 1;
    if (intranasalAntihistamines && intranasalAntihistaminesResult)
      validationCount += 1;

    if (validationCount >= 2) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    // Only reset if Treatment History Analysis was NOT loaded from sessionStorage (fresh start)
    // If it was loaded from storage (rollback), keep it as completed
    if (!treatmentAnalysisLoadedFromStorage.current) {
      setTreatmentAnalysis(false);
    }
  }, [
    oralAntihistamines,
    oralAntihistaminesConfirmation,
    oralAntihistaminesEffective,
    oralAntihistaminesLength,
    intranasalCorticosteroids,
    intranasalAntihistaminesAndCorticosteroidsConfirmation,
    intranasalCorticosteroidsEffective,
    intranasalCorticosteroidsProperUse,
    intranasalCorticosteroidsLength,
    intranasalAntihistaminesAndCorticosteroids,
    intranasalCorticosteroidsConfirmation,
    intranasalAntihistaminesAndCorticosteroidsProperUse,
    intranasalAntihistaminesAndCorticosteroidsEffective,
    intranasalAntihistaminesAndCorticosteroidsLength,
    // isSelectionChanged,
  ]);

  useEffect(() => {
    if (getAnyMissingInput()) {
      setSubStepComplete(false);
    } else {
      setSubStepComplete(true);
    }
  }, [
    nasalIrrigations,
    nasalIrrigationsLength,
    nasalIrrigationsEffective,
    nasalIrrigationsSideEffects,
    nasalOrOralDecongestants,
    nasalOrOralDecongestantsLength,
    nasalOrOralDecongestantsEffective,
    nasalOrOralDecongestantsSideEffects,
    nasalOrOralDecongestantsProperUse,
    oralAntihistamines,
    oralAntihistaminesConfirmation, // Added missing confirmation variable
    oralAntihistaminesLength,
    oralAntihistaminesEffective,
    oralAntihistaminesSideEffects,
    intranasalCorticosteroids,
    intranasalCorticosteroidsConfirmation, // Added missing confirmation variable
    intranasalCorticosteroidsLength,
    intranasalCorticosteroidsEffective,
    intranasalCorticosteroidsProperUse,
    intranasalCorticosteroidsSideEffects,
    intranasalAntihistaminesAndCorticosteroids,
    intranasalAntihistaminesAndCorticosteroidsConfirmation, // Added missing confirmation variable
    intranasalAntihistaminesAndCorticosteroidsLength,
    intranasalAntihistaminesAndCorticosteroidsEffective,
    intranasalAntihistaminesAndCorticosteroidsProperUse,
    intranasalAntihistaminesAndCorticosteroidsSideEffects,
    allergensAndIrritants,
    allergensAndIrritantsEffective,
    cardListToShow,
  ]);

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 w-full h-[668px] scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Treatment History - Non-Pharmacological and Pharmacological
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div
                className="grid grid-flow-col auto-cols-[480px] gap-6 scroll-smooth overflow-auto "
                id="treatmentHistory"
              >
                {!showSelectionPopup &&
                  cardListToShow
                    .filter((card) => card.display && card.value !== "none")
                    .sort((a, b) => (a.cardIndex || 999) - (b.cardIndex || 999))
                    .map((card, i) => {
                      const cardValue = getCard(card.value);
                      const value = getCardValue(card.value);
                      
                      return (
                        <div
                          key={card.value}
                          data-card-value={card.value}
                          className={clsx(
                            "relative"
                          )}
                        >
                          <QuestionCard
                            questionTitle={() => (
                              <h3 className="text-xl font-bold text-teal-600 ">
                                {cardValue?.header}
                              </h3>
                            )}
                            question={() =>
                              cardValue?.options?.length > 0 ? (
                                <div className="inline-block">
                                  <span className="font-semibold">
                                    {cardValue?.question}
                                  </span>
                                </div>
                              ) : null
                            }
                            subquestion={cardValue?.subquestion}
                            options={cardValue?.options}
                            optionClick={(value) => {
                              getCardComponentOptionClick(card.value, value);
                            }}
                            values={value}
                            isMulti={card.isMulti}
                            customComponent={() =>
                              getCardComponent(
                                card.value,
                                cardValue?.customInput
                              )
                            }
                          />
                        </div>
                      );
                    })}

                <EndServiceModel
                  open={showMedicalHistoryAlert || showTreatmentHistoryAlert}
                  title={
                    showTreatmentHistoryAlert
                      ? "Treatment History"
                      : "Medications History Alert"
                  }
                  showContinueAndRef={!showTreatmentHistoryAlert}
                  showContinueWithNoRef={!showTreatmentHistoryAlert}
                  showOTCConsultAndRef={!showTreatmentHistoryAlert}
                  showEndServiceAndRef={!showTreatmentHistoryAlert}
                  content={() => renderPopupContent()}
                  handleClose={() => {
                    setAlertConfirmation(0);
                    setAlertExplaination("");
                    if (showMedicalHistoryAlert) {
                      setShowMedicalHistoryAlert(false);
                    }
                    if (showTreatmentHistoryAlert) {
                      setShowTreatmentHistoryAlert(false);
                    }
                  }}
                  handleContinue={(ref, exp) => {
                    setAlertConfirmation(
                      ref
                        ? AlertConfirmationTypes.ContinueWithRefer
                        : AlertConfirmationTypes.ContinueWithNoReferral
                    );
                    setAlertExplaination(exp);
                    if (ref !== undefined) {
                      setShowRef(ref);
                    }
                    if (showMedicalHistoryAlert) {
                      setShowMedicalHistoryAlert(false);
                    }
                    if (showTreatmentHistoryAlert) {
                      setShowTreatmentHistoryAlert(false);
                      updateStepsVisibility(false);
                    }
                    setSubStepComplete(true);
                    setTreatmentAnalysis(true);
                    markTreatmentAnalysisCompleted();
                    treatmentAnalysisLoadedFromStorage.current = true;
                  }}
                  handleEndService={() => {
                    setShowRef(true);
                    setAlertConfirmation(AlertConfirmationTypes.EndService);
                    setAlertExplaination("");
                    if (showMedicalHistoryAlert) {
                      setShowTreatmentHistoryAlert(false);
                    }
                    if (showTreatmentHistoryAlert) {
                      setShowTreatmentHistoryAlert(false);
                    }
                    updateStepsVisibility(true);
                    setClickedEndService(true);
                  }}
                />

                <ConfirmationModalNew
                  open={showSelectionPopup}
                  title="Treatment History"
                  type="primary"
                  confirmText="Continue"
                  content={() => showSelectionContent()}
                  hideActions={true}
                  hideCloseIcon={false}
                  onCross={() => {
                    if (isEditSelection) {
                      setShowSelectionPopup(false);
                      setIsEditSelection(false);
                    } else {
                      onPrevious();
                    }
                  }}
                  handleClose={() => {
                    if (isEditSelection) {
                      setShowSelectionPopup(false);
                      setIsEditSelection(false);
                    } else {
                      onPrevious();
                    }
                  }}
                  confirmAction={() => {
                    setShowSelectionPopup(false);
                    setIsEditSelection(false);
                  }}
                  disableConfirm={false}
                />

                <ConfirmationModalNew
                  open={showNoHistoryDialog}
                  title="Medication History Analysis"
                  type="primary"
                  confirmText="Continue"
                  cancelText={null}
                  verticalButtons={true}
                  buttonClassName="w-full"
                  content={() => (
                  <div className="mb-4">
                    <span className="text-md-sm">
                      No issues have been identified with past medications.
                    </span>
                  </div>)}
                  onCross={() => {
                    setShowNoHistoryDialog(false);
                  }}
                  confirmAction={() => {
                    setTreatmentAnalysis(true);
                    markTreatmentAnalysisCompleted();
                    treatmentAnalysisLoadedFromStorage.current = true;
                    setShowNoHistoryDialog(false);
                  }}
                />

                {!showSelectionPopup && (
                  <div
                    className={`h-[585px] rounded-[4px] overflow-hidden flex flex-col relative 
                  ${subStepComplete && "border border-gray-100"}`}
                  >
                    {subStepComplete && (
                      <>
                        <div className="flex flex-row justify-start">
                          <button
                            data-tooltip-id="edit-treatment-history"
                            className="m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                            onClick={() => {
                              setIsEditSelection(true);
                              setShowSelectionPopup(true);
                              setContinueSelection(true);
                              setTreatmentAnalysis(false);
                              treatmentAnalysisLoadedFromStorage.current = false;
                            }}
                          >
                            <ChevronLeftIcon className="w-4 h-4 text-white" />
                          </button>
                          <NewToolTip
                            id="edit-treatment-history"
                            render={() => (
                              <div className="p-2 bg-white text-gray-800 text-sm shadow-lg rounded">
                                Navigate to Treatment History selection
                              </div>
                            )}
                          />
                        </div>
                        <div className="m-8 h-[420px] w-[420px] bg-blue-100 rounded-full flex items-center justify-center bg-opacity-40">
                          <ReactSVG
                            src={"/icons/analysis-pad.svg"}
                            className={``}
                          />
                        </div>
                        <div className="mx-7 my-5">
                          {!treatmentAnalysis && (
                            <Button
                              className="w-full !px-2 !text-xl"
                              type="primary"
                              text="Treatment History Analysis"
                              onClick={() => {
                                handleTreatmentAnalysis();
                              }}
                            />
                          )}
                          {treatmentAnalysis && (
                            <div>
                              <h4 className="text-xl text-REELTeal font-bold items-center justify-center flex">
                                Treatment History Analysis Complete
                              </h4>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={clsx("w-[200px] max-h-[52px] !rounded-[30px]")}
            disabled={
              !subStepComplete || showSelectionPopup || !treatmentAnalysis
            }
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default History;
